import { remove } from "lodash";

const key = "entity-security-deny-all";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]+\/security$/);
};

const modify = (resp) => {
	if(resp.data.Success !== true || !resp.data.Data) {
		return;
	}
	
	const assigned = resp.data.Data.Assigned;
	const role = resp.data.Data.Roles.find(r => r.Code === assigned[0].Code);

	remove(role.Actions, a => a.Path === "/types/**/*");
	
	const denyCreateDealer = { Effect: "Deny", Path: "/types/DEALER/write" };
	role.Actions.push(denyCreateDealer);

	const denyManageIdentifiers = { Effect: "Deny", Path: "/types/DEALER/identifiers/*/read" };
	role.Actions.push(denyManageIdentifiers);

	const denyAddIdentifiers = { Effect: "Deny", Path: "/types/DEALER/identifiers/*/create" };
	role.Actions.push(denyAddIdentifiers);

	const denyUpdateIdentifiers = { Effect: "Deny", Path: "/types/DEALER/identifiers/*/update" };
	role.Actions.push(denyUpdateIdentifiers);

	const denyDeactivateIdentifiers = { Effect: "Deny", Path: "/types/DEALER/identifiers/*/deactivate" };
	role.Actions.push(denyDeactivateIdentifiers);

	const denyReactivateIdentifiers = { Effect: "Deny", Path: "/types/DEALER/identifiers/*/reactivate" };
	role.Actions.push(denyReactivateIdentifiers);


	const denyManageClassifications = { Effect: "Deny", Path: "/types/DEALER/classifications/*/read" };
	role.Actions.push(denyManageClassifications);

	const denyAddClassifications = { Effect: "Deny", Path: "/types/DEALER/classifications/*/add" };
	role.Actions.push(denyAddClassifications);

	const denyDeactivateClassifications = { Effect: "Deny", Path: "/types/DEALER/classifications/*/remove" };
	role.Actions.push(denyDeactivateClassifications);

	
	const denyReadEffective = { Effect: "Deny", Path: "/types/DEALER/effective/*/read" };
	role.Actions.push(denyReadEffective);

	const denyAddEffective = { Effect: "Deny", Path: "/types/DEALER/effective/*/create" };
	role.Actions.push(denyAddEffective);

	const denyUpdateEffective = { Effect: "Deny", Path: "/types/DEALER/effective/*/update" };
	role.Actions.push(denyUpdateEffective);

	const denyDeactivateEffective = { Effect: "Deny", Path: "/types/DEALER/effective/*/delete" };
	role.Actions.push(denyDeactivateEffective);

	
	const denyManageContacts = { Effect: "Deny", Path: "/types/DEALER/contacts/*/read" };
	role.Actions.push(denyManageContacts);

	const denyAddContacts = { Effect: "Deny", Path: "/types/DEALER/contacts/*/create" };
	role.Actions.push(denyAddContacts);

	const denyUpdateContacts = { Effect: "Deny", Path: "/types/DEALER/contacts/*/update" };
	role.Actions.push(denyUpdateContacts);

	const denyDeactivateContacts = { Effect: "Deny", Path: "/types/DEALER/contacts/*/deactivate" };
	role.Actions.push(denyDeactivateContacts);

	const denyReactivateContacts = { Effect: "Deny", Path: "/types/DEALER/contacts/*/reactivate" };
	role.Actions.push(denyReactivateContacts);

	const denyManageRelationships = { Effect: "Deny", Path: "/types/DEALER/related/*/read" };
	role.Actions.push(denyManageRelationships);
};

export const entitySecurityDenyAll = [key, applicable, modify];